import { FC } from 'react';
import { TableCellProps } from '@servicetitan/table';
import { OutboundMessage } from '../api/telecom.api';

import * as Styles from './outbound-messages.module.less';

export const TextCell: FC<TableCellProps<OutboundMessage>> = ({ dataItem }) => (
    <td className={Styles.textCell}>{dataItem.text}</td>
);
